import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare, Facebook, Twitter, Instagram, Linkedin, X } from 'lucide-react';
const Footer: React.FC = () => {
  const [showForm, setShowForm] = useState(false);
  return <footer className="bg-gray-800 text-white" data-id="element-214">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-215">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-216">
          <div className="col-span-1 md:col-span-1" data-id="element-217">
            <div className="flex items-center mb-4" data-id="element-218">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8zmhit8gAFrjMDL53XE1oK/white_logo.png" alt="GoABitFurther Africa Logo" className="h-10 w-auto" data-id="element-219" />
            </div>
            <p className="text-gray-400 text-sm mb-4" data-id="element-220">
              Discover Modern Career Paths with Your Education Degree
            </p>
            <div className="flex space-x-4" data-id="element-221">
              <a href="https://web.facebook.com/GoABitFurtherAfrica" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white" data-id="element-222">
                <Facebook size={20} data-id="element-223" />
              </a>
              <a href="https://x.com/goabitfurther" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white" data-id="element-224">
                <Twitter size={20} data-id="element-225" />
              </a>
              <a href="https://instagram.com/goabitfurtherafrica" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white" data-id="element-226">
                <Instagram size={20} data-id="element-227" />
              </a>
              <a href="https://www.linkedin.com/company/goabitfurtherafrica/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white" data-id="element-228">
                <Linkedin size={20} data-id="element-229" />
              </a>
            </div>
          </div>
          <div data-id="element-230">
            <h3 className="text-lg font-semibold mb-4" data-id="element-231">Quick Links</h3>
            <ul className="space-y-2" data-id="element-232">
              <li data-id="element-233">
                <Link to="/" className="text-gray-400 hover:text-white text-sm" data-id="element-234">
                  Home
                </Link>
              </li>
              <li data-id="element-235">
                <Link to="/courses" className="text-gray-400 hover:text-white text-sm" data-id="element-236">
                  Career Paths
                </Link>
              </li>
              <li data-id="element-237">
                <Link to="/community" className="text-gray-400 hover:text-white text-sm" data-id="element-238">
                  Community
                </Link>
              </li>
              <li data-id="element-239">
                <Link to="/resources" className="text-gray-400 hover:text-white text-sm" data-id="element-240">
                  Resources
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-241">
            <h3 className="text-lg font-semibold mb-4" data-id="element-242">About</h3>
            <ul className="space-y-2" data-id="element-243">
              <li data-id="element-244">
                <Link to="/about" className="text-gray-400 hover:text-white text-sm" data-id="element-245">
                  About Us
                </Link>
              </li>
              <li data-id="element-246">
                <Link to="/contact" className="text-gray-400 hover:text-white text-sm" data-id="element-247">
                  Contact
                </Link>
              </li>
              <li data-id="element-248">
                <a href="#" className="text-gray-400 hover:text-white text-sm" data-id="element-249">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-250">
                <a href="#" className="text-gray-400 hover:text-white text-sm" data-id="element-251">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-252">
            <h3 className="text-lg font-semibold mb-4" data-id="element-253">Join Our Community</h3>
            <button onClick={() => setShowForm(true)} className="flex items-center bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md mb-4 text-sm" data-id="element-254">
              <MessageSquare size={16} className="mr-2" data-id="element-255" />
              Join Virtual Campus Community
            </button>
            {showForm && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-256">
                <div className="bg-white rounded-lg p-4 w-full max-w-3xl max-h-[90vh] overflow-auto" data-id="element-257">
                  <div className="flex justify-between items-center mb-4" data-id="element-258">
                    <h3 className="text-lg font-semibold text-gray-800" data-id="element-259">
                      Join Virtual Campus Community
                    </h3>
                    <button onClick={() => setShowForm(false)} className="text-gray-500 hover:text-gray-700" data-id="element-260">
                      <X size={20} data-id="element-261" />
                    </button>
                  </div>
                  <iframe src="https://docs.google.com/forms/d/e/1FAIpQLScFQEbe3h7flDUP33fOabd1s6s5WDmWAUB16zTt39u8_53ilg/viewform?embedded=true" width="100%" height="600" frameBorder="0" marginHeight={0} marginWidth={0} data-id="element-262">
                    Loading form...
                  </iframe>
                </div>
              </div>}
            <p className="text-gray-400 text-sm" data-id="element-263">
              Need support? Email us at:
              <a href="mailto:info@goabitfurtherafrica.site" className="block text-blue-400 hover:underline mt-1" data-id="element-264">
                info@goabitfurtherafrica.site
              </a>
            </p>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400 text-sm" data-id="element-265">
          <p data-id="element-266">
            &copy; {new Date().getFullYear()} GoABitFurther Africa. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;